import React, { Component } from 'react';

import './ExternalLink.css';
import linkIcon from '../icons/ic_link.svg';
import { trackInnerTextClick } from '../utils';

class ExternalLink extends Component {
  render() {

    const {
      name,
      url,
      gaMessage,
    } = this.props.data;
    const isCentered = this.props.isCentered;

    return (
      <div className="lp-external-link" style={{
        display: 'flex',
        justifyContent: isCentered ? 'center' : 'flex-start',
      }}>
        <a href={url} target="_blank" rel="noopener noreferrer" onClick={e => {
          trackInnerTextClick(e, gaMessage);
        }}>
          <span>{this.props.data.name}</span>
          <img width="18" height="18" src={linkIcon} alt={'Link for ' + name}/>
        </a>
      </div>
    );
  }
}

export default ExternalLink;



// WEBPACK FOOTER //
// ./src/components/ExternalLink.js